import { render, staticRenderFns } from "./add-ad-product-target.vue?vue&type=template&id=74b212ae&scoped=true&"
import script from "./add-ad-product-target.vue?vue&type=script&lang=js&"
export * from "./add-ad-product-target.vue?vue&type=script&lang=js&"
import style0 from "./add-ad-product-target.vue?vue&type=style&index=0&id=74b212ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b212ae",
  null
  
)

export default component.exports